import _kebabCase from "lodash/kebabCase";
import { colors } from '@datacamp/waffles-tokens';
var COLORS = Object.keys(colors);
var COLORS_HEX = Object.values(colors);

var checkValidColors = function checkValidColors(color) {
  if (color != null && !COLORS.includes(color)) {
    // eslint-disable-next-line no-console
    console.error("Use a waffles-compatible color: ".concat(color, " is disallowed"));
  }
};

var formatColor = function formatColor(color) {
  return _kebabCase(color).replace('_', '-');
};

var getColorClass = function getColorClass(color) {
  checkValidColors(color);
  return color != null ? "dc-u-color-".concat(formatColor(color)) : '';
};

getColorClass.validColors = COLORS;
getColorClass.validColorsHex = COLORS_HEX;

var getBackgroundClass = function getBackgroundClass(color) {
  checkValidColors(color);
  return color != null ? "dc-u-bgc-".concat(formatColor(color)) : '';
};

getBackgroundClass.validColors = COLORS;

var getFillColorClass = function getFillColorClass(color) {
  checkValidColors(color);
  return color != null ? "dc-u-fill-".concat(formatColor(color)) : '';
};

getFillColorClass.validColors = COLORS;
export { getColorClass, getBackgroundClass, getFillColorClass };